import { Route } from '@angular/router';
import { partnerResolver } from './partner.resolver';
import { mgsAdminGuard } from '../mgs-guards';
import { mgsIconsResolver } from '../mgs-svg-icon.helper';
import { PARTNER_PATH, PARTNER_TITLE } from '../mgs-path-defs';

export const partnerRoute: Route = {
  path: PARTNER_PATH,
  title: PARTNER_TITLE,
  resolve: { partner: partnerResolver, icons: mgsIconsResolver },
  canActivate: [mgsAdminGuard],
  loadComponent: () => import('./partner.component')
};
